var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 6.0415C10.3455 6.0415 10.6253 6.32133 10.6253 6.6665V9.37484H13.3337C13.6788 9.37484 13.9587 9.65466 13.9587 9.99984C13.9587 10.345 13.6788 10.6248 13.3337 10.6248H10.6253V13.3332C10.6253 13.6783 10.3455 13.9582 10.0003 13.9582C9.65515 13.9582 9.37533 13.6783 9.37533 13.3332V10.6248H6.66699C6.32181 10.6248 6.04199 10.345 6.04199 9.99984C6.04199 9.65466 6.32181 9.37484 6.66699 9.37484H9.37533V6.6665C9.37533 6.32133 9.65515 6.0415 10.0003 6.0415Z",
    fill: "#AFAEBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 2.2915C5.74313 2.2915 2.29199 5.74264 2.29199 9.99984C2.29199 14.257 5.74313 17.7082 10.0003 17.7082C14.2575 17.7082 17.7087 14.257 17.7087 9.99984C17.7087 5.74264 14.2575 2.2915 10.0003 2.2915ZM1.04199 9.99984C1.04199 5.05229 5.05277 1.0415 10.0003 1.0415C14.9479 1.0415 18.9587 5.05229 18.9587 9.99984C18.9587 14.9474 14.9479 18.9582 10.0003 18.9582C5.05277 18.9582 1.04199 14.9474 1.04199 9.99984Z",
    fill: "#AFAEBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddition);
export default __webpack_public_path__ + "static/media/icon_addition.080074ffa2d0da50d61264039bf77941.svg";
export { ForwardRef as ReactComponent };